import { Card } from "@/components/ui/card";
import { LucideIcon } from "lucide-react";

interface StatCardProps {
  title: string;
  value: number;
  icon: LucideIcon;
  color: "cyan" | "green" | "red";
}

const colorClasses = {
  cyan: "bg-cyan-50 dark:bg-cyan-950/20 text-cyan-600 dark:text-cyan-400",
  green: "bg-green-50 dark:bg-green-950/20 text-green-600 dark:text-green-400",
  red: "bg-red-50 dark:bg-red-950/20 text-red-600 dark:text-red-400",
};

export const StatCard = ({ title, value, icon: Icon, color }: StatCardProps) => (
  <Card className="p-6 border-slate-200 dark:border-slate-800">
    <div className="flex items-start justify-between">
      <div>
        <p className="text-sm text-slate-600 dark:text-slate-400 mb-1">
          {title}
        </p>
        <p className="text-2xl font-bold text-slate-900 dark:text-white">
          ${value.toLocaleString("en-US", { minimumFractionDigits: 2 })}
        </p>
      </div>
      <div className={`p-2 rounded-lg ${colorClasses[color]}`}>
        <Icon className="w-5 h-5" />
      </div>
    </div>
  </Card>
);
